// SC-2873 — a tiny cross-surface seam: "put the user in the chat composer".
// The View Library's "ask the agent to build a view" CTA lives across the
// component tree from the composer, so the request rides a window event (same
// pattern as the api client's `auth:lost`) instead of threading refs through
// the workspace shell.
//
// The PENDING flag covers the collapsed-panel case: callers un-collapse the
// panel (`appStore.setChatCollapsed(false)`) alongside the request, but the
// composer only MOUNTS on the next commit — after the event has already fired
// into a listener-less room. ChatInput therefore consumes the flag on mount
// too, so the focus lands whichever order mount and event arrive in.

export const CHAT_FOCUS_EVENT = 'ekom:focus-chat';

let pendingFocus = false;

export function requestChatFocus(): void {
  pendingFocus = true;
  window.dispatchEvent(new Event(CHAT_FOCUS_EVENT));
}

/** Read-and-clear the pending request. The composer calls this both from the
 *  event listener (mounted case) and on mount (was-collapsed case). */
export function consumePendingChatFocus(): boolean {
  const was = pendingFocus;
  pendingFocus = false;
  return was;
}
